import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/products/[slug]/not-found.tsx");
